interface Config {
  // apiUrl: string;
  environment: string;
  apiUrlWebsite: string;
  apiUrlConversationalEngine: string;
  apiUrlTemplates: string;
  apiUrlN8N: string;
  googleLoginScope: string;
  apiUrlAnalytics: string;
  fluxiUrl: string,
  servicesFluxiUrl: string,
  sentryDns: string,
  geoLocationApiUrl: string,
  apiUrlAnalyticsExperiments: string,
  apiUrlWhatsAppConfirmation: string,
  metaAppId: string,
  metaConfigId: string,
}

// interface ImportMetaEnv {
//   VITE_BASE_API_VENTAFLOW_IO_URL: string;
//   VITE_ENV: string;
// }

const config: Config = {
  //apiUrl: import.meta.env.VITE_BASE_API_VENTAFLOW_IO_URL || "",
  environment: import.meta.env.VITE_ENV || "development",
  apiUrlWebsite: import.meta.env.VITE_BASE_API_WEBSITE_URL || "",
  apiUrlConversationalEngine: import.meta.env.VITE_BASE_API_CONVERSATIONAL_ENGINE_URL || "",
  apiUrlTemplates: import.meta.env.VITE_BASE_LAMBDA_TEMPLATES_URL || "",
  apiUrlN8N: import.meta.env.VITE_BASE_API_N8N || "",
  googleLoginScope: import.meta.env.VITE_BASE_GOOGLE_LOGIN_SCOPE || "",
  apiUrlAnalytics: import.meta.env.VITE_BASE_API_EVENTS_PARTITION || "",
  apiUrlAnalyticsExperiments: import.meta.env.VITE_BASE_API_ANALYTICS || "",
  fluxiUrl: import.meta.env.VITE_FLUXI_URL,
  servicesFluxiUrl: import.meta.env.VITE_BASE_SERVICES_FLUXI_URL,
  sentryDns: import.meta.env.VITE_BASE_SENTRY_DNS,
  geoLocationApiUrl: import.meta.env.VITE_BASE_GEO_DATA_LAMBDA,
  apiUrlWhatsAppConfirmation: import.meta.env.VITE_BASE_API_WHATSAPP_CONFIRMATION_URL || "",
  metaAppId: import.meta.env.VITE_META_APP_ID || "",
  metaConfigId: import.meta.env.VITE_META_CONFIG_ID || "",
};

export const isDevelopment = config.environment === "development"
export const isProduction = config.environment === "production"

export default config
